import { put, call, select } from 'redux-saga/effects'
import { rolesApiService, handleError } from 'Services/ApiService.js'
import roleActions from 'Stores/Role/Actions'
import i18n from 'i18next'
import { IFToastMessage } from 'Components'
import { toaster } from 'rsuite'
import AdminSelectors from 'Stores/Admin/Selectors'
import AdminActions from 'Stores/Admin/Actions'
import IFFIlterType from 'Enums/IFFilterType'
import InfinityEnums from 'Enums/InfinityEnums'
import history from 'history/browser'
import { encodeObjectToBase64 } from '../Utils/Base64Functions'

var base64 = require('base-64')

export function* fetchRoles({}) {
  yield put(roleActions.fetchRolesLoading())

  try {
    const { data } = yield call(rolesApiService.get, '/')

    yield put(roleActions.fetchRolesSuccess(data))
  } catch (e) {
    yield put(roleActions.fetchRolesError(e))
    handleError(e)
  }
}
export function* fetchRolesWithAdmins({ offset }) {
  if (offset === 0) {
    yield put(roleActions.fetchRolesWithAdminsLoading())
  }

  try {
    const { data } = yield call(rolesApiService.get, '/rolesWithAdmins', {
      params: {
        offset: offset,
      },
    })

    yield put(
      roleActions.fetchRolesWithAdminsSuccess(
        offset,
        data.rolesWithAdmins,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(roleActions.fetchRolesWithAdminsError(e))
    handleError(e)
  }
}

export function* fetchRolesCount() {
  yield put(roleActions.fetchRolesCountLoading())
  try {
    const { data } = yield call(rolesApiService.get, '/count')
    yield put(roleActions.fetchRolesCountSuccess(data.count))
  } catch (e) {
    yield put(roleActions.fetchRolesCountFail(e))
    handleError(e)
  }
}

export function* updateRole({ roleId, newRoleName, newRolePermissions }) {
  yield put(roleActions.updateRoleLoading(roleId))

  try {
    const { data } = yield call(rolesApiService.patch, `/${roleId}`, {
      name: newRoleName,
      permissions: newRolePermissions,
    })

    yield put(roleActions.updateRoleSuccess(data))
  } catch (e) {
    yield put(roleActions.updateRoleFail(roleId))

    handleError(e)
  }
}
export function* createRole({ role }) {
  yield put(roleActions.createRoleLoading())
  try {
    const { data } = yield call(rolesApiService.post, '/', {
      name: role.roleName,
      country: role.country,
      permissions: role.permissions,
    })
    yield put(roleActions.createRoleSuccess(data))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('RoleList.RoleSuccessCreated')}
      />,
    )
  } catch (e) {
    yield put(roleActions.createRoleFail())
    handleError(e)
  }
}
export function* deleteRole({ roleId }) {
  yield put(roleActions.deleteRoleLoading(roleId))

  try {
    yield call(rolesApiService.delete, `/${roleId}`)
    yield put(roleActions.deleteRoleSuccess(roleId))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('RoleList.RoleDeletedSuccessfully')}
      />,
    )
  } catch (e) {
    yield put(roleActions.deleteRoleFail(roleId))
    handleError(e)
  }
}
export function* fetchRoleAdminList({ roleId, offset }) {
  yield put(roleActions.fetchRoleAdminListLoading())

  try {
    const { data } = yield call(rolesApiService.get, `/${roleId}/admins`, {
      params: {
        offset: offset,
      },
    })
    yield put(
      roleActions.fetchRoleAdminListSuccess(
        offset,
        data.admins,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(roleActions.fetchRoleAdminListFail())
    handleError(e)
  }
}
export function* fetchAllRoles({ offset, isFiltering, roleName }) {
  yield put(roleActions.fetchAllRolesLoading())
  let adminFilter = yield select(AdminSelectors.getAdminsFilters)
  try {
    const { data } = yield call(rolesApiService.get, '/all', {
      params: {
        offset: offset,
        roleName: roleName,
      },
    })
    yield put(
      roleActions.fetchAllRolesSuccess(
        offset,
        data.response.roles,
        data.response.nextOffset,
      ),
    )

    if (isFiltering) {
      const updatedFilters = adminFilter.map((filter) => {
        if (
          filter.type === IFFIlterType.CHECK &&
          filter.title === InfinityEnums.IFFilterTitle.Role
        ) {
          const newRoleNames = data.response.roles.map((role) => role.name)
          return {
            ...filter,
            data:
              offset !== 0 ? [...filter.data, ...newRoleNames] : newRoleNames,
          }
        }
        return filter
      })
      history.push({
        search: `?filter=${encodeObjectToBase64(updatedFilters)}&tab=${0}`,
      })
      yield put(AdminActions.updateAdminFilter(updatedFilters))
    }
  } catch (e) {
    yield put(roleActions.fetchAllRolesFail())
    handleError(e)
  }
}
